import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillGithub, AiFillInstagram, AiFillLinkedin } from "react-icons/ai";
import styled from "styled-components";

const StyledFooter = styled.footer`
  background-color: rgba(17, 24, 39, 0.95);
  padding: 2.5rem 0 2rem;
  margin-top: 2rem;
  box-shadow: 0 -5px 20px rgba(0, 0, 0, 0.15);
  
  .footer-body {
    z-index: 1;
    text-align: center;
    position: relative;
  }
  
  .footer-copywright {
    text-align: center;
    margin-bottom: 1rem;
    margin-top: 1.5rem;
    color: var(--text-secondary);
    font-size: 1rem;
    font-weight: 500;
  }
  
  .footer-social {
    display: flex;
    justify-content: center;
    gap: 25px;
    margin-bottom: 1.5rem;
  }
  
  .social-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: rgba(56, 189, 248, 0.1);
    border: 1px solid rgba(56, 189, 248, 0.3);
    color: var(--imp-text-color);
    font-size: 1.5rem;
    transition: all 0.3s ease;
    
    &:hover {
      background-color: var(--imp-text-color);
      color: white;
      transform: scale(1.1);
      box-shadow: 0 0 15px rgba(56, 189, 248, 0.5);
    }
  }
  
  .divider {
    width: 100%;
    max-width: 800px;
    height: 1px;
    background-color: rgba(203, 213, 225, 0.1);
    margin: 0 auto 1.8rem;
  }
  
  @media (max-width: 767px) {
    padding: 2rem 0 1.5rem;
    
    .social-icon {
      width: 45px;
      height: 45px;
      font-size: 1.3rem;
    }
    
    .footer-social {
      gap: 18px;
    }
    
    .footer-copywright {
      font-size: 0.9rem;
    }
  }
`;

function Footer() {
  let date = new Date();
  let year = date.getFullYear();

  return (
    <StyledFooter>
      <Container>
        <div className="divider" />
        <Row>
          <Col md="12" className="footer-body">
            <div className="footer-social">
              <a
                href="https://github.com/mehdidch59"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Github"
              >
                <AiFillGithub />
              </a>
              <a
                href="https://linkedin.com/in/mehdichafai"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Linkedin"
              >
                <AiFillLinkedin />
              </a>
              <a
                href="https://instagram.com/mehdidc"
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                aria-label="Instagram"
              >
                <AiFillInstagram />
              </a>
            </div>
            <div className="footer-copywright">
              <p>Copyright © {year} Mehdi Chafai</p>
            </div>
          </Col>
        </Row>
      </Container>
    </StyledFooter>
  );
}

export default Footer;